import { default as donate_46clientOoWILA7cVBMeta } from "/opt/buildhome/repo/pages/[campaignSlug]/donate.client.vue?macro=true";

let _createClientPage
async function createClientPage(loader) {
  _createClientPage ||= await import("/opt/buildhome/repo/node_modules/nuxt/dist/components/runtime/client-component").then(r => r.createClientPage)
  return _createClientPage(loader);
}
import { default as donationsXnWq5DoWjhMeta } from "/opt/buildhome/repo/pages/[campaignSlug]/donations.vue?macro=true";
import { default as goalsn3b6rQqWGPMeta } from "/opt/buildhome/repo/pages/[campaignSlug]/goals.vue?macro=true";
import { default as indexO6mFWnS7GSMeta } from "/opt/buildhome/repo/pages/[campaignSlug]/index.vue?macro=true";
import { default as testimoniesw3tluze4cDMeta } from "/opt/buildhome/repo/pages/[campaignSlug]/testimonies.vue?macro=true";
import { default as _91campaignSlug_93iHp8mJsdZYMeta } from "/opt/buildhome/repo/pages/[campaignSlug].vue?macro=true";
import { default as receipts_46clientKAZC89eizHMeta } from "/opt/buildhome/repo/pages/receipts.client.vue?macro=true";
export default [
  {
    name: _91campaignSlug_93iHp8mJsdZYMeta?.name ?? undefined,
    path: _91campaignSlug_93iHp8mJsdZYMeta?.path ?? "/:campaignSlug()",
    meta: _91campaignSlug_93iHp8mJsdZYMeta || {},
    alias: _91campaignSlug_93iHp8mJsdZYMeta?.alias || [],
    redirect: _91campaignSlug_93iHp8mJsdZYMeta?.redirect,
    component: () => import("/opt/buildhome/repo/pages/[campaignSlug].vue").then(m => m.default || m),
    children: [
  {
    name: donate_46clientOoWILA7cVBMeta?.name ?? "campaignSlug-donate___pt-BR",
    path: donate_46clientOoWILA7cVBMeta?.path ?? "donate",
    meta: donate_46clientOoWILA7cVBMeta || {},
    alias: donate_46clientOoWILA7cVBMeta?.alias || [],
    redirect: donate_46clientOoWILA7cVBMeta?.redirect,
    component: () => createClientPage(() => import("/opt/buildhome/repo/pages/[campaignSlug]/donate.client.vue").then(m => m.default || m))
  },
  {
    name: donationsXnWq5DoWjhMeta?.name ?? "campaignSlug-donations___pt-BR",
    path: donationsXnWq5DoWjhMeta?.path ?? "donations",
    meta: donationsXnWq5DoWjhMeta || {},
    alias: donationsXnWq5DoWjhMeta?.alias || [],
    redirect: donationsXnWq5DoWjhMeta?.redirect,
    component: () => import("/opt/buildhome/repo/pages/[campaignSlug]/donations.vue").then(m => m.default || m)
  },
  {
    name: goalsn3b6rQqWGPMeta?.name ?? "campaignSlug-goals___pt-BR",
    path: goalsn3b6rQqWGPMeta?.path ?? "goals",
    meta: goalsn3b6rQqWGPMeta || {},
    alias: goalsn3b6rQqWGPMeta?.alias || [],
    redirect: goalsn3b6rQqWGPMeta?.redirect,
    component: () => import("/opt/buildhome/repo/pages/[campaignSlug]/goals.vue").then(m => m.default || m)
  },
  {
    name: indexO6mFWnS7GSMeta?.name ?? "campaignSlug___pt-BR",
    path: indexO6mFWnS7GSMeta?.path ?? "",
    meta: indexO6mFWnS7GSMeta || {},
    alias: indexO6mFWnS7GSMeta?.alias || [],
    redirect: indexO6mFWnS7GSMeta?.redirect,
    component: () => import("/opt/buildhome/repo/pages/[campaignSlug]/index.vue").then(m => m.default || m)
  },
  {
    name: testimoniesw3tluze4cDMeta?.name ?? "campaignSlug-testimonies___pt-BR",
    path: testimoniesw3tluze4cDMeta?.path ?? "testimonies",
    meta: testimoniesw3tluze4cDMeta || {},
    alias: testimoniesw3tluze4cDMeta?.alias || [],
    redirect: testimoniesw3tluze4cDMeta?.redirect,
    component: () => import("/opt/buildhome/repo/pages/[campaignSlug]/testimonies.vue").then(m => m.default || m)
  }
]
  },
  {
    name: receipts_46clientKAZC89eizHMeta?.name ?? "receipts___pt-BR",
    path: receipts_46clientKAZC89eizHMeta?.path ?? "/receipts",
    meta: receipts_46clientKAZC89eizHMeta || {},
    alias: receipts_46clientKAZC89eizHMeta?.alias || [],
    redirect: receipts_46clientKAZC89eizHMeta?.redirect,
    component: () => createClientPage(() => import("/opt/buildhome/repo/pages/receipts.client.vue").then(m => m.default || m))
  }
]